import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import authService from '../../services/AuthService';
import api, { apiErrorHandler } from '../../services/AxiosService';
import queryString from 'query-string';
import tourDef from '../../productTour/TourDef';
import { alertPopup, apiErrorPopup } from '../../helpers/MessagePopup';

/*
 * AutoLogin is responsible for auto-logging in a user and routing them to the appropriate cade page
 */

export class AutoLogin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            redirectPage: null
        }

        authService.clearAuthenticated();
    }

    componentDidMount = () => {
   
        // Get the values from the query string (credentials, providerid, page) and build a rest call
        let params = queryString.parse(this.props.location.search);

        // Make a REST call to authenticate the user.  If valid, initialize authService; else, issue a message a try again
        api.post("account/autologin", {
            EncodedCredentials: params.cr,
            ProviderId: params.pv,
            Page: params.pg
        })
        .then(response => {
            if (response.status == 200) {
                // Set the tour run state in the singleton
                tourDef.setRunTours(response.data.runTours);

                // Retain authenticated user information in the authService.  
                authService.setAuthenticated(response.data.authenticationModel.token, response.data.authenticationModel.accessToken, response.data.authenticationModel.id, response.data.authenticationModel.userName, response.data.authenticationModel.userFirstName, response.data.authenticationModel.userLastName,
                    response.data.authenticationModel.userDegrees, response.data.authenticationModel.isGuest, response.data.authenticationModel.isRater1, response.data.authenticationModel.isRater2, response.data.authenticationModel.isRater3,
                    response.data.authenticationModel.isPartnerProvider, response.data.authenticationModel.partnerRole, response.data.authenticationModel.restrictedDomains);

                if (response.data.page == "/cade") {
                    // Setup person lists and assessment lists if the user is going beyond getting started or home

                    // Set the assessment state (accessible assessments, current assessment, etc.) in App.js passively (no render wanted)
                    this.props.assessmentStateHandler(response.data.personFirstName, response.data.personLastName, response.data.personBirthDate, response.data.personAge,
                        response.data.assessmentsModel.assessments, response.data.providerId, response.data.assessmentId, response.data.assessmentDate);

                    // Set the personList into app.js state (passively - no render wanted)
                    this.props.personListHandler(response.data.personListModel.personList);
                }
                // Set state to force a re-render that will redirect through App.js
                this.setState({ redirectPage: response.data.page });
            }
            else {
                // Hmmm, not a error (not found) so something else...
                alertPopup('warning', "Auto Login Error.  Please contact the individual the provided this link and ask them for a new one.");
                this.setState({ redirectPage: "/" });
            }
        })
        .catch(error => {
            let errorMessage = apiErrorHandler(error);
            apiErrorPopup("Auto Login Error: " + errorMessage + ".  Please login with your credentials.");
            this.setState({ redirectPage: "/" });
        });
    }

    render() {

        // BEWARE debugging in certain places (like the render method.  It gets optimized away and you undefined for lots of things when they really aren't!

        // If the user is already authenticated, redirect to the home page.  The only way they get to be here is if they are not authenticated.

        if (this.state.redirectPage == null) {
            return (null);
        }
        else {
            if (authService.isAuthenticated) {
                return (<Redirect to={this.state.redirectPage} />);
            }
            else {
                return (<Redirect to="/" />);
            }
        }
    }
}

export default AutoLogin;




// WEBPACK FOOTER //
// ./src/components/Login/AutoLogin.js